export default "__VITE_ASSET__BYLRcHZv__"